(function() {
    if (customElements.get('base-bullet-wrap') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        @keyframes bounce {
          0% {transform: translate(0)}
          66% {transform: translateY(-20%)}
          100% {transform: translate(0)}
        }
        :host {
          --bullet-wrap-bg: black;
          --bullet-wrap-fg: white;
          --bullet-wrap-size-base: 1rem;
          --bullet-animation: bounce;
          --bullet-animation-speed: 1s;
          --bullet-animation-state: running;
          position: relative;
          display: inline-block;
          color: var(--bullet-wrap-fg);
          width: var(--bullet-wrap-size-base);
          height: var(--bullet-wrap-size-base);
          padding: var(--bullet-wrap-size-base);
        }
        :host([animate]) [part="content"] {
          animation: var(--bullet-animation) var(--bullet-animation-speed) ease 0s infinite both var(--bullet-animation-state);
        }
        [part="content"] {
          position: relative;
          z-index: 1;
        }
        [part="bullet"] {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 0;
          border-radius: 100%;
          background-color: var(--bullet-wrap-bg);
        }
        </style>
        <div part="content">
            <slot></slot>
        </div>
        <div part="bullet"></div>
        `;
        customElements.define('base-bullet-wrap', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }
        });
    }
})();
